import React, { useState, useEffect } from "react";
import dashboardclasses from "../../dashboard.module.css";
import { IoClose } from "react-icons/io5";
import { FileUploader } from "react-drag-drop-files";
import { BsCloudUpload } from "react-icons/bs";
import { useForm } from "react-hook-form";
import { Services } from "../../../Services";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import {
    validateNegativeValues,
    validateEmptySpaces,
} from "../../../Components/utils/validations";
function AddCategory(props) {
    const Navigate = useNavigate();
    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };
    const {
        register,
        handleSubmit,
        reset,
        getValues,
        setValue,
        watch,
        formState: { errors },
    } = useForm();
    const [base64, setbase64] = useState("");
    const watchFormData = watch();
    useEffect(() => {
        if (props.editable) {
            reset({ ...props.editable });
            setbase64(`${props.editable.imageURL}`);
        }
        const close = (e) => {
            if (e.key == "Escape") {
                console.log("close");
                props.setmodal(false);
                props.setEditable(false);
            }
        };
        window.addEventListener("keydown", close);
        return () => window.removeEventListener("keydown", close);
    }, []);

    const CancelHandler = (e) => {
        e.stopPropagation();
        props.setmodal(false);
        props.setEditable(false);
    };

    const openhandler = (e) => {
        e.stopPropagation();
    };
    const handleChange = (file) => {
        if (file.type === "image/png" || file.type === "image/jpeg") {
            setValue("img", file);
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                setbase64(reader.result);
            };
            reader.onerror = function (error) {
                console.log("Error: ", error);
            };
        } else {
            alert("please upload image in PNG and JPEG format ");
        }
    };

    const fileuploadDesign = (
        <div className={dashboardclasses["add-item"]}>
            <BsCloudUpload className={dashboardclasses["upload-icon"]} />
            <h5>Drag Your Image here</h5>
            <p>(Only *.jpeg and *.png images will be accepted)</p>
        </div>
    );

    const onSubmit = (data) => {
        let formaata = new FormData();
        Object.keys(data).forEach((key) => {
            formaata.set(key, data[key]);
        });

        if (!props.editable) {
            if (!data.img) {
                swal("image is required", "", "warning");
                return;
            }
            fetch(
                `${process.env.REACT_APP_BASE_URL_NODE}/${Services.add_service_Categories}`,
                {
                    method: "POST",
                    body: formaata,
                    Authorization: `token ${sessionStorage.getItem("token")}`,
                }
            )
                .then((response) => response.json())
                .then((res) => {
                    console.log(res);
                    if (res.Status === 1) {
                        Navigate(`/service-categories?page=1`);
                        props.setpageCount(1);
                        props.tableload(true);
                        props.setmodal(false);
                        props.getCategories();

                        toast.success(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    } else if (res.Status === 0) {
                        toast.error(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                })
                .catch((error) => {
                    props.tableload(false);
                    alert("something went wrong please try again");
                    console.log(error);
                });
        } else if (props.editable) {
            let oldvalues = props.editable;
            console.log(oldvalues);
            let updated_Values;
            if (oldvalues.categoryname != watchFormData.categoryname) {
                updated_Values = {
                    ...updated_Values,
                    categoryname: watchFormData.categoryname,
                };
            }
            if (oldvalues.priority != watchFormData.priority) {
                updated_Values = {
                    ...updated_Values,
                    priority: watchFormData.priority,
                };
            }
            if (oldvalues.status != watchFormData.status) {
                updated_Values = {
                    ...updated_Values,
                    status: watchFormData.status,
                };
            }
            if (data?.img) {
                updated_Values = {
                    ...updated_Values,
                    img: watchFormData.img,
                };
            }
            console.log(updated_Values);
            if (!updated_Values) {
                swal("No changes to apply", "", "warning");
                return;
            }
            updated_Values = { ...updated_Values, _id: oldvalues._id };
            let updated = new FormData();
            Object.keys(updated_Values).forEach((key) => {
                updated.set(key, updated_Values[key]);
            });
            fetch(
                `${process.env.REACT_APP_BASE_URL_NODE}/${Services.Update_service_Categories}`,
                {
                    method: "POST",
                    body: updated,
                    Authorization: `token ${sessionStorage.getItem("token")}`,
                }
            )
                .then((response) => response.json())
                .then((res) => {
                    console.log(res);
                    if (res.Status === 1) {
                        props.tableload(true);
                        Navigate(`/service-categories?page=1`);
                        props.setpageCount(1);
                        props.setmodal(false);
                        props.getCategories();
                        props.setEditable(false);
                        toast.success(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    } else if (res.Status === 0) {
                        toast.error(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                })
                .catch((error) => {
                    props.tableload(false);
                    alert("something went wrong please try again");
                    console.log(error);
                });
        }
    };

    return (
        <div className={dashboardclasses.modal} onClick={CancelHandler}>
            <div
                className={dashboardclasses["modal-content"]}
                onClick={openhandler}>
                <div className={dashboardclasses["modal-content-header"]}>
                    <div>
                        <h3>
                            {props.editable
                                ? "Update Category"
                                : "Add Category"}
                        </h3>
                        <p>
                            {props.editable
                                ? "Update Category"
                                : "Add Category"}{" "}
                            and necessary information from here
                        </p>
                    </div>
                    <button
                        className={dashboardclasses["close-btn"]}
                        onClick={CancelHandler}>
                        <IoClose size={22} color={"red"} />
                    </button>
                </div>
                <form
                    className={dashboardclasses["add-items"]}
                    onSubmit={handleSubmit(onSubmit)}>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryName">Category Name</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                disabled={props.editable}
                                {...register("categoryname", {
                                    required: "category Name is required",
                                    validate: validateEmptySpaces,
                                })}
                            />

                            {errors?.categoryname && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.categoryname?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="category">Category Icon</label>

                        <FileUploader
                            classes={dashboardclasses["upload-image"]}
                            multiple={false}
                            handleChange={handleChange}
                            name="file"
                            children={fileuploadDesign}
                            // types={fileTypes}
                        />
                    </div>
                    <div className={dashboardclasses["uploaded-img"]}>
                        <img src={base64} alt="" width={"120px"} />
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="">Priority</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="number"
                                {...register("priority", {
                                    required: "priority is required",
                                    validate: validateNegativeValues,
                                })}
                            />
                            {errors?.priority && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.priority?.message}
                                </p>
                            )}
                        </div>
                    </div>

                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="status">Status</label>
                        <div className={dashboardclasses["select"]}>
                            <select
                                {...register("status", {
                                    required: "status is required",
                                })}>
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                            </select>
                            {errors?.status && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.status?.message}
                                </p>
                            )}
                        </div>
                    </div>

                    <div className={dashboardclasses["add-btn"]}>
                        <button type="button" onClick={CancelHandler}>
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className={dashboardclasses["add-category-btn"]}>
                            {props.editable ? "update" : "Add Category"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default AddCategory;
